import React from "react";
import { Redirect, Route } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { AuthConsumer } from "../Auth";
import { Role } from "../../Services/auth";

interface RoleRouteProps {
  role: Role;
}

function RoleRoute(props: any) {
  const { children, role, ...rest } = props;
  return (
    <AuthConsumer>
      {({ isInRole, isAuthenticated }) => {
        if (!isAuthenticated()) {
          return <Redirect to="/login" />;
        }
        if (isInRole(role)) {
          return <Route {...rest}>{children}</Route>;
        } else {
          return (
            <Route {...rest}>
              <Typography>Unauthorized</Typography>
            </Route>
          );
        }
      }}
    </AuthConsumer>
  );
}

export default RoleRoute;
